import {
  Box,
  Button,
  ButtonGroup,
  ChoiceList,
  DatePicker,
  Filters,
  Icon,
  InlineStack,
  OptionList,
  Popover,
  Tabs,
  Tooltip,
  useIndexResourceState,
} from "@shopify/polaris";
import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
import {
  ChevronDownIcon,
  ArrowRightIcon,
  SortIcon,
} from "@shopify/polaris-icons";
import "./index.css";
import OrderListTable from "./OrderListTable";
import {
  reqGetOrderNewShopifyList,
  // reqGetProductManagementProductsQuestionnaire,
} from "../../../../api";
import SearchLoading from "../../../../components/SearchLoading";
import CommonTableFilterSkeletonList from "../common/CommonTableFilterSkeletonList";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
// import { useSelector } from "react-redux";
const OrderListFilterBox = ({
  toastFun,
  setWalletData,
  setAutoData,
  setSyncLogData,
  syncOpen,
  setSyncOpen,
  handleStoreTabChange,
  isGuideRef,
}) => {
  const [selected, setSelected] = useState(0); //tab 选择状态
  const [initPage, setInitPage] = useState(true); // 初始化页面
  const [listData, setListData] = useState({}); //列表数据
  const [newcomeGuidance, setNewcomeGuidance] = useState(false);
  const [collapsibleItem,setCollapsibleItem] = useState(false)// 展开所有子项
  const [newcomeStep, setNewcomeStep] = useState({
    step1: true,
    step2: false,
    step3: false,
  });
  const [searchLoading, setSearchLoading] = useState(false); // 页面加载
  const [searchBtnLoading, setSearchBtnLoading] = useState(false); // 搜索按钮加载
  const [requestParams, setRequestParams] = useState({
    page: 1,
    size: 20,
    tag: 1,
    payment_type: [],
    fulfill_type: [],
    start_time: "",
    end_time: "",
    dot_type: [],
    query_value: "",
    search_key: ["shopify"],
    sort_by: "",
  }); // 请求参数
  const [active, setActive] = useState(null); //搜索 按钮展开

  const [tabData, setTabData] = useState([
    {
      id: "a1",
      content: "All",
      accessibilityLabel: "All customers",
      panelID: "a1",
    },
    {
      id: "a2",
      content: <span>Pending Sourcing(0)</span>,
      panelID: "a2",
    },
    {
      id: "a3",
      content: <span>Unpaid(0)</span>,
      panelID: "a3",
    },
    {
      id: "a4",
      content: <span>In Processing(0)</span>,
      panelID: "a4",
    },
    {
      id: "a5",
      content: <span>Fulfilled(0)</span>,
      panelID: "a5",
    },
    {
      id: "a6",
      content: <span>Exceptions(0)</span>,
      panelID: "a6",
    },
    {
      id: "a7",
      content: <span>Archived(0)</span>,
      panelID: "a7",
    },
  ]);
  // const plan_level = useSelector(
  //   (state) => state.languageReducer.subScriptData
  // );
  // 产品费力度调查
  const getUserProductSurvey = async () => {
    try {
      // let res = await reqGetProductManagementProductsQuestionnaire({
      //   event: "order_management",
      // });
      // if (res.code === "200") {
      //   if (!res.data) {
      //     window.onOrderFulfillment(plan_level);
      //   }
      // }
    } catch (error) {}
  };
  // 使用 useMemo 缓存可选的订单列表，减少不必要的计算
  const selectableOrders = useMemo(() => {
    const filteredList = listData?.list;
    // 如果过滤后为空则回退到原始列表，否则用过滤结果
    return filteredList;
  }, [listData?.list]); // 明确依赖 listData.list 和 selected
  const { selectedResources, allResourcesSelected, handleSelectionChange } =
    useIndexResourceState(selectableOrders);
  const isMount = useRef(false);

  const dayShow = (isoDate) => {
    // 1. 创建Date对象
    const date = new Date(isoDate);

    const year = date.getFullYear(); // 2025
    let month = date.getMonth() + 1; // 月份从0开始需+1 → 2
    let day = date.getDate(); // 1
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    // 3. 组合成 Y-M-D 格式（自动去除前导零）
    return `${year}-${month}-${day}`;
  };
  const router = useHistory();
  const getPageData = (data, id) => {
    const { search } = router.location;
    const params = new URLSearchParams(search);
    const order_number = params.get("order_number");
    const from = params.get("from");
    const newParams = new URLSearchParams();
    newParams.set("selectedView", 0);

    // 使用 replace 避免新增历史记录
    router.replace({
      pathname: "/admin/order_fulfillment",
      search: newParams.toString(),
    });
    // utils.routeListen("/admin/order_fulfillment?selectedView=0");
    setRequestParams((prev) => {
      let query_value = data?.query_value || prev?.query_value || "";
      let search_key = data?.search_key || prev?.search_key || ["shopify"];
      let page = data?.page || prev?.page || 1;
      let size = data?.size || prev?.size || 20;
      if (order_number && order_number !== "") {
        query_value = order_number;
        page = 1;
        size = 20;
        if (from && from === "message") {
          search_key = ["dsm"];
        } else {
          search_key = ["shopify"];
        }
      }
      if (data?.query_value === "") {
        query_value = "";
        search_key = ["shopify"];
      }

      getNewData(
        {
          ...prev,
          ...data,
          query_value: query_value,
          search_key: search_key,
          page,
          size,
        },
        id
      );
      // 更新 queryParams 状态（确保 setRequestParams 能获得最新数据）
      return {
        ...prev,
        ...data,
        query_value: query_value,
        search_key: search_key,
        page,
        size,
      };
    });
  };
  const getNewData = async (data, id) => {
    try {
      let params = {
        ...data,
      };
      if (params.start_time) {
        params.start_time = dayShow(params.start_time);
      }
      if (params.end_time) {
        params.end_time = dayShow(params.end_time);
      }
      params.search_key = params.search_key[0];

      let res = await reqGetOrderNewShopifyList(params);
      if (res.code === "200") {
        setNewcomeGuidance(res.data.order_guide ? true : false);
        isGuideRef.current = res.data.order_guide ? true : false;
        setSyncLogData(res.data);
        setAutoData((prev) => ({
          ...prev,
          autoSourcing: res.data.auto_sourcing,
          autoFulfillment: res.data.auto_pay,
        }));
        setWalletData(res.data.wallet_money);

        if (id) {
          let list = res.data.list.map((item, ind) => {
            if (item.id === id) {
              return { ...item, show: 1 };
            }
            return item;
          });
          setListData({
            ...res.data,
            list: list,
          });
        } else {
          let list2 = res.data.list;
          let flag = false;
          for (let i = 0; i < list2.length; i++) {
            if (
              list2[i].dsm_paid_at >= 1745510400 ||
              process.env.REACT_APP_ENV === "test" ||
              process.env.REACT_APP_ENV === "dev"
            ) {
              flag = true;
              break;
            }
          }
          if (flag) {
            getUserProductSurvey();
          }

          setListData(res.data);
        }
        let summary = res.data.summary;
        if (summary) {
          setTabData([
            {
              id: "a1",
              content: "All",
              accessibilityLabel: "All customers",
              panelID: "a1",
            },
            {
              id: "a2",
              content: (
                <Tooltip
                  preferredPosition="below"
                  content={"Sourcing incomplete for some or all products"}
                  hasUnderline
                >
                  <span>Pending Sourcing({summary.pending_sourcing_cnt})</span>
                </Tooltip>
              ),
              panelID: "a2",
            },
            {
              id: "a3",
              content: (
                <Tooltip
                  preferredPosition="below"
                  content={"Payment not completed in Dropshipman"}
                  hasUnderline
                >
                  <span>Unpaid({summary.unpaid_cnt})</span>
                </Tooltip>
              ),
              panelID: "a3",
            },
            {
              id: "a4",
              content: (
                <Tooltip
                  preferredPosition="below"
                  content={
                    "Order is being inspected, packed, and prepared for shipment"
                  }
                  hasUnderline
                >
                  <span>In Processing({summary.in_processing_cnt})</span>
                </Tooltip>
              ),
              panelID: "a4",
            },
            {
              id: "a5",
              content: (
                <Tooltip
                  preferredPosition="below"
                  content={"Order shipped and in transit"}
                  hasUnderline
                >
                  <span>Fulfilled</span>
                </Tooltip>
              ),
              panelID: "a5",
            },
            {
              id: "a6",
              content: (
                <Tooltip
                  preferredPosition="below"
                  content={"Invalid address or shipping option — action needed"}
                  hasUnderline
                >
                  <span>Exceptions({summary.issues_cnt})</span>
                </Tooltip>
              ),
              panelID: "a6",
            },
            {
              id: "a7",
              content: <span>Archived({summary.archived_cnt})</span>,
              panelID: "a7",
            },
          ]);
        }
      } else {
      }
      setInitPage(false);
      setSearchLoading(false);
      setSearchBtnLoading(false);
      setCollapsibleItem(false)
      handleSelectionChange("page", false, 0);
    } catch (error) {}
  };
  const handleTabChange = (selectedTabIndex) => {
    setSearchLoading(true);
    setSelected(selectedTabIndex);
    getPageData({
      page: 1,
      size: 20,
      tag: selectedTabIndex + 1,
      payment_type: [],
      fulfill_type: [],
      start_time: "",
      end_time: "",
      dot_type: [],
      query_value: "",
      search_key: ["shopify"],
      sort_by: "",
    });
    handleSelectionChange("page", false, 0);
  };
  const location = router.location;
  const searchParams = new URLSearchParams(location.search);
  const order_number = searchParams.get("order_number");
  useEffect(() => {
    if (!isMount.current) {
      getPageData();
    }
    if (isMount.current && order_number) {
      getPageData();
    }
    return () => {
      isMount.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [order_number]);

  useEffect(() => {
    if (syncOpen) {
      getPageData();
      setSyncOpen(false); // 执行后立即关闭，避免重复触发
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncOpen]); // 依赖项优化后，仅在 syncOpen 或 getPageData 变化时触发
  const toggleActive = (id) => () => {
    // 搜索按钮展开和关闭
    setActive((activeId) => (activeId !== id ? id : null));
  };

  const handlePaymentStatusChange = (value) => {
    getPageData({ page: 1, payment_type: value });
  };
  const handleFiltersQueryChange = useCallback(
    (value) => {
      if (value.length > 255) {
        return;
      }
      setRequestParams((prev) => ({
        ...prev,
        query_value: value,
      }));
    },
    [setRequestParams]
  );
  const handlePaymentStatusRemove = () => {
    getPageData({ page: 1, payment_type: [] });
  };
  const handleFulfillMentChange = (value) => {
    getPageData({ page: 1, fulfill_type: value });
  };
  const handleFulfillMentRemove = () => {
    getPageData({ page: 1, fulfill_type: [] });
  };
  const handleDotsChange = (value) => {
    getPageData({ page: 1, dot_type: value });
  };
  const handleDotsRemove = () => {
    getPageData({ page: 1, dot_type: [] });
  };
  const currentDate = new Date();
  const [{ month, year }, setDate] = useState({
    month: currentDate.getMonth(),
    year: currentDate.getFullYear(),
  }); // 添加日期
  // 添加日期
  const handleListedDateChange = (value) => {
    getPageData({
      page: 1,
      start_time: value.start,
      end_time: value.end,
    });
  };
  const handleListedDateRemove = (value) => {
    getPageData({
      page: 1,
      start_time: "",
      end_time: "",
    });
    handleSelectionChange("page", false, 0);
  };
  // 月份改变
  const handleMonthChange = useCallback(
    (month, year) => setDate({ month, year }),
    []
  );

  const handleQueryValueRemove = () => {
    getPageData({ page: 1, query_value: "" });
  };
  const handleFiltersClearAll = () => {
    getPageData({
      page: 1,
      payment_type: [],
      fulfill_type: [],
      start_time: "",
      end_time: "",
      dot_type: [],
      query_value: "",
      search_key: ["shopify"],
      sort_by: "",
    });
  };
  const handleSearchSelect = (value) => {
    setRequestParams((prev) => ({
      ...prev,
      search_key: value,
    }));
  };

  const filters = [
    {
      key: "payment_status",
      label: "Payment status",
      filter: (
        <ChoiceList
          title="Payment status"
          titleHidden
          choices={[
            { label: "Paid(Shopify)", value: 1 },
            { label: "Pending(Shopify)", value: 2 },
            { label: "Unpaid(Shopify)", value: 3 },
            {
              label: "Partially paid(Shopify)",
              value: 4,
            },
            {
              label: "Refunded(Shopify)",
              value: 5,
            },
            {
              label: "Partially Refunded(Shopify)",
              value: 6,
            },
            { label: "Paid(DSM)", value: 7 },
            { label: "Pending(DSM)", value: 8 },
            { label: "Unpaid(DSM)", value: 9 },
            {
              label: "Partially paid(DSM)",
              value: 10,
            },
            { label: "Refunded(DSM)", value: 11 },
            {
              label: "Partially Refunded(DSM)",
              value: 12,
            },
          ]}
          selected={requestParams.payment_type || []}
          onChange={handlePaymentStatusChange}
          allowMultiple
        />
      ),
      pinned: true,
    },
    {
      key: "fulfillment_status",
      label: "Fulfillment status",
      filter: (
        <ChoiceList
          title="Fulfillment status"
          titleHidden
          choices={[
            {
              label: "Unfulfilled(Shopify)",
              value: 1,
            },
            {
              label: "Fulfilled(Shopify)",
              value: 2,
            },
            { label: "Unfulfilled(DSM)", value: 3 },
            { label: "Fulfilled(DSM)", value: 4 },
          ]}
          selected={requestParams.fulfill_type || []}
          onChange={handleFulfillMentChange}
          allowMultiple
        />
      ),
      pinned: true,
    },
    {
      key: "createdDate",
      label: (
        <Box>
          <InlineStack blockAlign="center" gap={200} wrap={false}>
            <span>Start</span>
            <Icon source={ArrowRightIcon} tone="base" />
            <span>End</span>
          </InlineStack>
        </Box>
      ),
      filter: (
        <DatePicker
          month={month}
          year={year}
          onChange={handleListedDateChange}
          onMonthChange={handleMonthChange}
          selected={
            requestParams.start_time && requestParams.end_time
              ? {
                  start: requestParams.start_time,
                  end: requestParams.end_time,
                }
              : undefined
            // 没有选择任何日期时传递 undefined
            // 没有选择任何日期时传递 undefined
          }
          multiMonth
          allowRange
        />
      ),
      pinned: true,
    },
    {
      key: "dot",
      label: "Color Tag",
      filter: (
        <ChoiceList
          title="Color Tag"
          titleHidden
          choices={[
            { label: "Red", value: 1 },
            { label: "Brown", value: 2 },
            { label: "Green", value: 3 },
            { label: "Blue", value: 4 },
            { label: "Gray", value: 5 },
            { label: "None", value: 0 },
          ]}
          selected={requestParams.dot_type || []}
          onChange={handleDotsChange}
          allowMultiple
        />
      ),
      pinned: true,
    },
  ];

  const appliedFilters = [];
  if (requestParams.payment_type && !isEmpty(requestParams.payment_type)) {
    const key = "payment_status";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams.payment_type),
      onRemove: handlePaymentStatusRemove,
    });
  }
  if (requestParams.fulfill_type && !isEmpty(requestParams.fulfill_type)) {
    const key = "fulfillment_status";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams.fulfill_type),
      onRemove: handleFulfillMentRemove,
    });
  }
  if (requestParams.start_time && requestParams.end_time) {
    const key = "createdDate";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams),
      onRemove: handleListedDateRemove,
    });
  }
  if (!isEmpty(requestParams.dot_type)) {
    const key = "dot";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, requestParams.dot_type),
      onRemove: handleDotsRemove,
    });
  }
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (requestParams.query_value !== "" && !searchLoading) {
        getPageData({
          page: 1,
          query_value: requestParams.query_value.trim(),
        });
        setSearchLoading(true);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestParams]);
  const labelFun = () => {
    let text = "Product keywords";
    if (requestParams.search_key[0] === "dsm") {
      text = "Filter DSM order";
    }
    if (requestParams.search_key[0] === "shopify") {
      text = "Filter Shopify order";
    }
    return text;
  };
  const [sortShow, setSortShow] = useState(false);
  const handleSortChange = (value) => {
    if (value[0] === "dsm") {
      getPageData({
        page: 1,
        sort_by: "dsm",
      });
    } else {
      getPageData({
        page: 1,
        sort_by: "shopify",
      });
    }
  };
  const pageContent = (
    <Box>
      <Box className="order_list_tab">
        <InlineStack
          gap={200}
          align="space-between"
          wrap={false}
          blockAlign="center"
        >
          <Tabs
            tabs={tabData}
            selected={selected}
            onSelect={handleTabChange}
          ></Tabs>
          {selected > 1 && selected < 5 ? (
            <Box className="order_list_tab_sort">
              <Popover
                active={sortShow}
                activator={
                  <Button
                    icon={SortIcon}
                    onClick={() => {
                      setSortShow(!sortShow);
                    }}
                  ></Button>
                }
                autofocusTarget="first-node"
                onClose={() => {
                  setSortShow(false);
                }}
              >
                <OptionList
                  onChange={handleSortChange}
                  options={[
                    {
                      value: "dsm",
                      label: "DSM order number from high to low",
                    },
                    {
                      value: "shopify",
                      label: "Shopify order number from high to low",
                    },
                  ]}
                  selected={requestParams.sort_by || []}
                  shortcut={true}
                />
              </Popover>
            </Box>
          ) : (
            ""
          )}
        </InlineStack>
      </Box>
      <Box className="product_filter">
        <Filters
          queryPlaceholder={labelFun()}
          queryValue={requestParams.query_value}
          filters={filters}
          appliedFilters={appliedFilters}
          onQueryChange={handleFiltersQueryChange}
          onQueryClear={handleQueryValueRemove}
          onClearAll={handleFiltersClearAll}
        >
          <Box paddingInlineStart="0">
            <ButtonGroup variant="segmented">
              <Button
                onClick={() => {
                  getPageData({
                    page: 1,
                    query_value: requestParams.query_value.trim(),
                  });
                  setSearchLoading(true);
                  setSearchBtnLoading(true);
                }}
                size="micro"
                loading={searchBtnLoading}
              >
                Search
              </Button>
              <Popover
                active={active === "popover1"}
                preferredAlignment="right"
                activator={
                  <Button
                    // disabled={queryParams.q === ''}
                    onClick={toggleActive("popover1")}
                    icon={ChevronDownIcon}
                    size="micro"
                    loading={false}
                  ></Button>
                }
                autofocusTarget="first-node"
                onClose={toggleActive("popover1")}
              >
                <OptionList
                  onChange={handleSearchSelect}
                  options={[
                    { value: "title", label: "Product keywords" },
                    { value: "dsm", label: "DSM order number" },
                    { value: "shopify", label: "Shopify order number" },
                  ]}
                  selected={requestParams.search_key || []}
                />
              </Popover>
            </ButtonGroup>
          </Box>
        </Filters>
      </Box>
      <OrderListTable
        selected={selected}
        listData={listData}
        getPageData={getPageData}
        requestParams={requestParams}
        setSearchLoading={setSearchLoading}
        loading={false}
        toastFun={toastFun}
        setListData={setListData}
        selectableOrders={selectableOrders}
        selectedResources={selectedResources}
        allResourcesSelected={allResourcesSelected}
        handleSelectionChange={handleSelectionChange}
        handleStoreTabChange={handleStoreTabChange}
        newcomeGuidance={newcomeGuidance}
        setNewcomeGuidance={setNewcomeGuidance}
        isGuideRef={isGuideRef}
        newcomeStep={newcomeStep}
        setNewcomeStep={setNewcomeStep}
        collapsibleItem={collapsibleItem}
        setCollapsibleItem={setCollapsibleItem}
      />
    </Box>
  );
  return (
    <div style={{ position: "relative" }}>
      {initPage ? <CommonTableFilterSkeletonList /> : pageContent}
      {searchLoading && <SearchLoading />}
    </div>
  );
};

function disambiguateLabel(key, value) {
  switch (key) {
    case "payment_status":
      let pay_status = [
        { label: "Paid(Shopify)", value: 1 },
        { label: "Pending(Shopify)", value: 2 },
        { label: "Unpaid(Shopify)", value: 3 },
        {
          label: "Partially paid(Shopify)",
          value: 4,
        },
        {
          label: "Refunded(Shopify)",
          value: 5,
        },
        {
          label: "Partially Refunded(Shopify)",
          value: 6,
        },
        { label: "Paid(DSM)", value: 7 },
        { label: "Pending(DSM)", value: 8 },
        { label: "Unpaid(DSM)", value: 9 },
        {
          label: "Partially paid(DSM)",
          value: 10,
        },
        { label: "Refunded(DSM)", value: 11 },
        {
          label: "Partially Refunded(DSM)",
          value: 12,
        },
      ];
      return (
        "Payment status: " +
        value
          ?.map(
            (val) =>
              pay_status.find((status) => status.value === val)?.label ||
              "Unknown"
          )
          .join(", ")
      );
    case "fulfillment_status":
      let fulfillment_status = [
        {
          label: "Unfulfilled(Shopify)",
          value: 1,
        },
        {
          label: "Fulfilled(Shopify)",
          value: 2,
        },
        { label: "Unfulfilled(DSM)", value: 3 },
        { label: "Fulfilled(DSM)", value: 4 },
      ];
      return (
        "Fulfillment status: " +
        value
          ?.map(
            (val) =>
              fulfillment_status.find((status) => status.value === val)
                ?.label || "Unknown"
          )
          .join(", ")
      );
    case "createdDate":
      let startDate1 = new Date(value.start_time);
      let endDate1 = new Date(value.end_time);

      if (value.start_time === value.end_time) {
        // Single day format
        return (
          <Box>
            <InlineStack blockAlign="center" gap={200} wrap={false}>
              <span>
                {startDate1.toLocaleDateString("en-US", {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                })}
              </span>
              <Icon source={ArrowRightIcon} tone="base" />
              <span>End</span>
            </InlineStack>
          </Box>
        );
      } else {
        const startYear = startDate1.getFullYear();
        const endYear = endDate1.getFullYear();

        // Base format without year
        const baseFormat = { month: "short", day: "numeric" };

        if (startYear === endYear) {
          // Same year - show year once at the end
          const startStr = startDate1.toLocaleDateString("en-US", baseFormat);
          const endStr = endDate1.toLocaleDateString("en-US", baseFormat);
          return (
            <Box>
              <InlineStack blockAlign="center" gap={200} wrap={false}>
                <span>{startStr}</span>
                <Icon source={ArrowRightIcon} tone="base" />
                <span>
                  {endStr}, {startYear}
                </span>
              </InlineStack>
            </Box>
          );
        } else {
          // Different years - show full date for both
          const fullFormat = { ...baseFormat, year: "numeric" };
          const startStr = startDate1.toLocaleDateString("en-US", fullFormat);
          const endStr = endDate1.toLocaleDateString("en-US", fullFormat);
          return (
            <Box>
              <InlineStack blockAlign="center" gap={200} wrap={false}>
                <span>{startStr}</span>
                <Icon source={ArrowRightIcon} tone="base" />
                <span>{endStr}</span>
              </InlineStack>
            </Box>
          );
        }
      }
    case "dot":
      let dotList = [
        { label: "Red", value: 1 },
        { label: "Brown", value: 2 },
        { label: "Green", value: 3 },
        { label: "Blue", value: 4 },
        { label: "Gray", value: 5 },
        { label: "None", value: 0 },
      ];
      return (
        "Tag status: " +
        value
          ?.map(
            (val) =>
              dotList.find((status) => status.value === val)?.label || "Unknown"
          )
          .join(", ")
      );
    default:
      return value;
  }
}

function isEmpty(value) {
  if (Array.isArray(value)) {
    return value.length === 0;
  } else {
    return value === "" || value == null;
  }
}
export default OrderListFilterBox;
